import React from 'react';
import { Button, Form, OverlayTrigger, Popover, Spinner } from 'react-bootstrap';
import { ICronJob } from '../../models/ICronJob';
import { useUpdateCronJobActiveMutation } from '../../store/api/cronJobsApi';
import { formatDate } from '../../utils/functions';

type CronJobsListItemProps = {
    cronJob: ICronJob;
    onCronJobEdit: (cronJob: ICronJob) => void;
    onCronJobDelete: (cronJob: ICronJob) => void;
}

const CronJobsListItem: React.FC<CronJobsListItemProps> = ({ cronJob, onCronJobEdit, onCronJobDelete }) => {

    const [updateCronJobActive, { isLoading }] = useUpdateCronJobActiveMutation();

    const onStatusUpdated = async (e: React.ChangeEvent<HTMLInputElement>) => {
        await updateCronJobActive({
            alias: cronJob.alias,
            active: e.target.checked,
        });
    }

    return (
        <tr>
            <td>
                {cronJob.title}
                <OverlayTrigger
                    trigger="click"
                    rootClose
                    placement="top"
                    overlay={
                        <Popover id={`cron-job-description-${cronJob.id}`}>
                            <Popover.Body style={{ whiteSpace: 'pre-wrap', userSelect: 'text' }}>
                                {cronJob.description || 'No description'}
                            </Popover.Body>
                        </Popover>
                    }
                >
                    <span className="d-inline-block ms-2 text-muted" style={{ cursor: 'help' }}>
                        &#9432;
                    </span>
                </OverlayTrigger>
            </td>
            <td>{cronJob.alias}</td>
            <td>
                <div className='d-flex align-items-center'>
                    <Form.Check
                        type="switch"
                        id={`cron-job-switch-${cronJob.id}`}
                        checked={cronJob.active}
                        onChange={onStatusUpdated}
                        disabled={isLoading}
                        label={cronJob.active ? 'Active' : 'Inactive'}
                        style={{ cursor: isLoading ? 'default' : 'pointer' }}
                        className={isLoading ? '' : 'cursor-pointer'}
                    />
                    {isLoading && <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className='ms-2' />}
                </div>
            </td>
            <td>
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {formatDate(new Date(cronJob.created_at))}
                </div>
            </td>
            <td>
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {cronJob.updated_at ? formatDate(new Date(cronJob.updated_at)) : ''}
                </div>
            </td>
            <td>
                <div className='d-flex flex-wrap gap-2'>
                    <Button variant="secondary" size="sm" onClick={() => onCronJobEdit(cronJob)}>Edit</Button>
                    <Button variant="danger" size="sm" onClick={() => onCronJobDelete(cronJob)}>Delete</Button>
                </div>
            </td>
        </tr>
    );
};

export default CronJobsListItem;
